import { _js } from '@ifixit/localize';
import { RangeSlider } from 'Shared/range_slider';
import { MediaTarget } from 'Shared/FrameModules/MediaLibrary/target';
import { SuggestProducts, SuggestGuides } from 'Shared/suggest';
import { trackAnalyticsCustomEvent } from '@ifixit/analytics';
import { Auth } from 'Shared/auth';
import { FormLibrary } from 'Shared/utils/form-library';
import { Utils } from 'Shared/utils';
import Validation from 'Shared/validation';
import { FormManager } from 'Shared/form_manager';

onDomReady(() => {
   NewStory.initialize();
});

const NewStory = {
   initialize: function () {
      this.complaintSubmit = $('complaintSubmitBtn');
      this.submitBtn = $('submitBtn');
      this.deleteBtn = $('deleteBtn');
      this.storyContentPage = $('storyContainer');
      this.storyForm = $('storyForm');
      this.guideInput = $('story-guide-input');
      this.guideFields = $('story-guide-fields');
      this.storyDifficulty = $('story-difficulty');
      this.timeTaken = $('story-time-taken');
      this.storyTitle = $('storyTitleInput');
      this.storyIntro = $('storyIntroBox');
      this.storyBody = $('storyBodyBox');
      this.storyConclusion = $('storyConclusionBox');
      this.productInput = $('story-product-input');

      this.recommendPage = $('recommend');
      this.yesBtn = $('recYes');
      this.noBtn = $('recNo');

      this.complaintPage = $('complaintFormContainer');
      this.complaintEmail = $('complaintEmail');
      this.complaintText = $('complaintTextBox');

      this.saving = false;
      this.timeSlider = null;

      this.titleMaxChars = 80;
      this.titleMinChars = 8;

      if (this.recommendPage) {
         this.setupRecommendAndComplaint();
      }

      this.setupFormManager();

      this.setupGuideAndProductDropdowns();
      this.setupMediaTargets();

      $$('.js-open-select').addEvent('click', function () {
         let select = this.getPrevious('select');
         let ev = new MouseEvent('mousedown', {
            bubbles: true,
            cancelable: true,
            view: window,
         });
         select.dispatchEvent(ev);
      });

      Utils.UnsavedChanges.addHandler(() => {
         if (!this.saving && this.formMan.modified) {
            return _js('You have unsaved changes. Your changes will be lost if you continue.');
         }
      });
   },

   setupRecommendAndComplaint: function () {
      this.yesBtn.addEvent('click', ev => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Story',
            eventAction: 'Recommendation Accepted',
         });
         this.recommendPage.addClass('hidden');
         this.storyContentPage.removeClass('hidden');
         this.toggleGuideFields(this.guideFields.isVisible());
      });

      this.noBtn.addEvent('click', ev => {
         trackAnalyticsCustomEvent({
            eventCategory: 'Story',
            eventAction: 'Recommendation Declined',
         });
         this.saving = true;

         this.recommendPage.addClass('hidden');
         this.storyContentPage.addClass('hidden');
         this.complaintPage.removeClass('hidden');
      });

      this.complaintFormMan = new FormManager('complaintForm');
      this.complaintFormMan.required(this.complaintEmail, this.complaintText);

      this.complaintFormMan.setValidator(this.complaintEmail, el => {
         let value = el.value.trim();
         if (el.hasClass('defaultText') || value === '') {
            return this.complaintFormMan.requiredError();
         }
         if (!Validation.email(value)) {
            return this.complaintFormMan.requiredError(_js('Invalid email address'));
         }
      });

      function updateSubmit() {
         this.complaintFormMan.checkIfValid(valid => {
            this.complaintSubmit.toggleClass('disabled', !valid);
         });
      }

      $$([this.complaintEmail, this.complaintText]).addEvents({
         blur: updateSubmit.bind(this),
         keyup: updateSubmit.bind(this),
      });
   },

   setupFormManager: function () {
      let defaultTitleText = '';
      let defaultIntroText = '';
      let defaultBodyText = '';
      let defaultConclusionText = '';

      this.formMan = new FormManager(this.storyForm);

      this.formMan.setDefaultText(this.storyTitle, defaultTitleText);
      this.formMan.setDefaultText(this.storyIntro, defaultIntroText);
      this.formMan.setDefaultText(this.storyBody, defaultBodyText);
      this.formMan.setDefaultText(this.storyConclusion, defaultConclusionText);

      this.formMan.setValidator(this.storyTitle, () => {
         let value = this.storyTitle.get('value').trim();
         if (this.storyTitle.hasClass('defaultText') || value === '') {
            this.markFinished(this.storyTitle, false);
            return this.formMan.requiredError();
         }
         if (value.length > this.titleMaxChars || value.length <= this.titleMinChars) {
            this.markFinished(this.storyTitle, false);
            return this.formMan.requiredError(
               _js('Title must be beween %1 and %2 characters')
                  .replace('%1', this.titleMinChars)
                  .replace('%2', this.titleMaxChars)
            );
         }
         this.markFinished(this.storyTitle, true);
      });

      function requiredValidator(field_name) {
         return function () {
            let el = this[field_name];
            let value = el.get('value').trim();
            let minLength = el.dataset.minlength;
            if (el.hasClass('defaultText') || value.length < minLength) {
               this.markFinished(el, false);
               return this.formMan.requiredError(
                  _js('This text must be at least %1 characters').replace('%1', minLength)
               );
            }
            this.markFinished(el, true);
         };
      }

      this.formMan.setValidator(this.storyIntro, requiredValidator('storyIntro').bind(this));

      this.formMan.setValidator(this.storyBody, requiredValidator('storyBody').bind(this));

      this.formMan.setValidator(
         this.storyConclusion,
         requiredValidator('storyConclusion').bind(this)
      );

      function updateStorySubmit() {
         this.formMan.checkIfValid(valid => {
            this.submitBtn.toggleClass('disabled', !valid);
         });
      }

      FormLibrary.getFields(this.storyForm).forEach(element => {
         element.addEvents({
            blur: updateStorySubmit.bind(this),
            keyup: updateStorySubmit.bind(this),
         });
      });

      this.formMan.addSubmitHandler(() => {
         if (this.saving) {
            return;
         }

         Auth.required({
            message: _js('Log in to submit a story'),
            onAuthorize: function () {
               this.saving = true;

               new Request.API_2_0(App.storyEditUrl, {
                  method: App.storyEditMethod,
                  statusPanelMessage: _js('Saving...'),
                  onSuccess: function (story) {
                     trackAnalyticsCustomEvent({
                        eventCategory: 'Story',
                        eventAction: 'Story Submitted',
                     });
                     window.location = story.view_url;
                  },
                  onFailure: function (xhr, message) {
                     if (xhr.status === 429) {
                        let story = JSON.parse(xhr.response);
                        window.location = story.view_url;
                     } else {
                        this.saving = false;
                     }
                  }.bind(this),
               }).send(this.getFormValues());
            }.bind(this),
         });
      });

      when(this.deleteBtn, deleteBtn => {
         deleteBtn.addEvent('click', function (ev) {
            let confirmMessage = _js('Are you sure you want to delete this story?');
            if (confirm(confirmMessage)) {
               new Request.API_2_0(App.storyEditUrl, {
                  method: 'DELETE',
                  statusPanelMessage: _js('Deleting...'),
                  onSuccess: function () {
                     trackAnalyticsCustomEvent({
                        eventCategory: 'Story',
                        eventAction: 'Story Deleted',
                     });

                     window.location = App.storyListUrl;
                  },
                  onFailure: function (xhr, message) {
                     this.saving = false;
                  }.bind(this),
               }).send();
            }
         });
      });
   },

   setupGuideAndProductDropdowns: function () {
      function autoFillInput(field, selected, selection) {
         let blurb = selected.retrieve('blurb');

         field.set('data-query', blurb.queryValue);
         field.set('data-title', blurb.title);

         if (blurb.guideid) {
            field.set('data-guideid', blurb.guideid);
         } else {
            field.set('data-productcode', blurb.productCode);
         }
      }

      when(this.guideInput, guideField => {
         let value;
         let guideid;
         guideField.addEvents({
            focus: function (ev) {
               this.getParent('.story-guide').addClass('focused');
               value = this.value;
               guideid = this.get('data-guideid');
            },
            blur: function (ev) {
               this.getParent('.story-guide').removeClass('focused');
               let newValue = this.value;
               if (!newValue) {
                  this.erase('data-guideid');
                  NewStory.markFinished(guideField, false);
                  NewStory.toggleGuideFields(false);
               } else if (newValue == this.get('data-query')) {
                  this.set('value', this.get('data-title'));
               } else if (newValue != this.get('data-title')) {
                  this.set('value', value);
                  this.set('data-guideid', guideid);
               }

               if (this.get('data-guideid')) {
                  NewStory.markFinished(guideField, true);
               }
            },
         });

         new SuggestGuides(guideField, {
            visibleChoices: false,
            onSelection: function (selected) {
               let blurb = selected.retrieve('blurb');
               let timeIndex = App.timeValues.indexOf(blurb.time_required_max);
               this.storyDifficulty.set('value', blurb.difficulty);
               this.toggleGuideFields(true);
               this.timeSlider.set(timeIndex);
               guideField.blur();
            }.bind(this),
            onSelect: autoFillInput,
         });
      });

      // Initialize slider if guideFields are already visible.
      if (this.guideFields.isVisible()) {
         this.toggleGuideFields(true);
      }

      when(this.productInput, productField => {
         let value;
         let productcode;
         productField.addEvents({
            focus: function (ev) {
               value = this.value;
               productcode = this.get('data-productcode');
            },
            blur: function (ev) {
               let newValue = this.value;
               if (!newValue) {
                  this.erase('data-productcode');
                  NewStory.markFinished(productField, false);
               } else if (newValue == this.get('data-query')) {
                  this.set('value', this.get('data-title'));
               } else if (newValue != this.get('data-title')) {
                  this.set('value', value);
                  this.set('data-productcode', productcode);
               }

               if (this.get('data-productcode')) {
                  NewStory.markFinished(productField, true);
               }
            },
         });

         new SuggestProducts(productField, {
            hideOptions: true,
            onSelection: function (selected) {
               productField.blur();
            },
            onSelect: autoFillInput,
            queryParams: { showOneOption: true },
         });
      });
   },

   setupMediaTargets: function () {
      let imageTargets = [];
      let videoTarget;

      $$('#story-image-upload .mediaTarget').each(targetElement => {
         let imageTarget = MediaTarget.createFromElement(targetElement, {
            customAttach: customAttach,
         });
         imageTargets.push(imageTarget);
      });

      $$('#story-video-upload .mediaTarget').each(targetElement => {
         videoTarget = MediaTarget.createFromElement(targetElement, {
            iconClass: 'addVideo',
            customAttach: customAttach,
         });
         videoTarget.addEvent('itemChanged', item => {
            if (!item) {
               let videoUpload = videoTarget.element.getParent('.js-media-upload');
               let imageUpload = imageTargets[0].element.getParent('.js-media-upload');
               if (imageUpload.hasClass('hidden')) {
                  NewStory.showHideMediaUpload(imageUpload, /*hide=*/ false);
               }
               videoUpload.addClass('hidden-mobile');
            }
            NewStory.markFinished(videoTarget.element, item);
         });
      });

      for (let i = 1; i < imageTargets.length; i++) {
         if (!imageTargets[i].mediaItem) {
            imageTargets[i].element.addClass('hidden-mobile');
         }
      }

      $$('.story-mobile-upload').addEvent('click:relay(.js-add-another)', () => {
         let empty = imageTargets.find(mediaTarget => !mediaTarget.mediaItem);

         if (empty) {
            empty.element.fireEvent('click');
         }
      });

      imageTargets.forEach(imageTarget => {
         imageTarget.addEvent('itemChanged', item => {
            let allEmpty = !imageTargets.find(mediaTarget => mediaTarget.mediaItem);

            let allFull = !imageTargets.find(mediaTarget => !mediaTarget.mediaItem);

            let videoUpload = videoTarget.element.getParent('.js-media-upload');
            if (allEmpty && videoUpload.hasClass('hidden')) {
               NewStory.showHideMediaUpload(videoUpload, /*hide=*/ false);
            }

            if (!item && imageTarget.element.hasClass('thumbnail')) {
               imageTarget.element.addClass('hidden-mobile');
            }

            NewStory.markFinished(imageTarget.element, !allEmpty);
            $$('.story-mobile-upload').toggleClass('hidden', allEmpty || allFull);
         });
      });

      function customAttach(mediaItem, finished) {
         let target = this;
         let otherTargets = [];
         let itemType = mediaItem && mediaItem.getType();
         let confirmMessage;

         // Placing video on image target
         if (itemType == 'GuideVideoObject' && target !== videoTarget) {
            confirmMessage = _js(
               'Placing this video will remove any images on this story. Do you want to continue?'
            );
            target = videoTarget;
            otherTargets = imageTargets;

            // Placing image on video target
         } else if (itemType === 'GuideImage' && target === videoTarget) {
            confirmMessage = _js(
               'Placing this image will clear the video from this story. Do you want to continue?'
            );
            target = imageTargets[0];
            otherTargets = [videoTarget];
         } else if (mediaItem && mediaItem.data.filter_state() !== true) {
            alert(target.getErrorMessage(mediaItem));
            return finished(mediaItem, false);
         }

         let confirmed = !confirmMessage || confirm(confirmMessage);
         let oldTarget;
         if (confirmed) {
            oldTarget = attach(target, mediaItem, otherTargets);
         }

         if (finished) {
            return finished(oldTarget, confirmed);
         }
      }

      function attach(target, mediaItem, otherTargets) {
         if (mediaItem) {
            let upload = target.element.getParent('.js-media-upload');
            let other = upload.getSiblings('.js-media-upload')[0];
            NewStory.showHideMediaUpload(other, /*hide=*/ true);
            upload.removeClass('hidden');
            upload.removeClass('hidden-mobile');
            target.element.removeClass('hidden-mobile');
         }

         if (otherTargets) {
            otherTargets.each(target => {
               attach(target, null, null);
            });
         }

         return target._immediatelyAttach(mediaItem);
      }
   },

   showHideMediaUpload: function (upload, hide) {
      let or = upload.getSiblings('p')[0];

      upload.toggleClass('hidden', hide);
      or.toggleClass('hidden', hide);
   },

   toggleGuideFields: function (show) {
      this.guideFields.toggleClass('hidden', !show);

      if (show && !this.timeSlider) {
         let timeRequiredText = $$('.js-timeRequiredText')[0];
         let initialValue = this.timeTaken.value.toInt();

         this.timeSlider = new RangeSlider($('timeSlider'), {
            type: 'single',
            range: [0, App.timeValues.length - 1],
            position: [0, App.timeValues.indexOf(initialValue)],
            onChange: function (value) {
               if (value) {
                  timeRequiredText.set('text', App.timeValuesText[value]);
               }
            },
            onComplete: function (value) {
               this.timeTaken.set('value', App.timeValues[value]);
               timeRequiredText.set('text', App.timeValuesText[value]);
            }.bind(this),
         });
      }
   },

   markFinished: function (el, finished) {
      let field = el.getParent('.story-field');
      field.getFirst('.finished-icon').toggleClass('hidden', !finished);
   },

   getFormValues: function () {
      let values = {
         title: this.storyTitle.value.trim(),
         intro: this.storyIntro.value,
         body: this.storyBody.value,
         conclusion: this.storyConclusion.value,
         images: this.getImageids(),
         object: this.getObjectid(),
         guides: this.getGuideids(),
         difficulty: this.getDifficulty(),
         time_taken: this.getTimeTaken(),
         products: this.getProducts(),
      };

      if (App.storyOrder) {
         values.order = App.storyOrder;
      }

      return values;
   },

   getImageids: function () {
      let imageids = [];

      let imageContainer = $('story-image-upload');
      imageContainer.getElements('.mediaTarget input').each(image => {
         let imageid = Number.parseInt(image.value, 10);
         if (imageid) {
            imageids.push(imageid);
         }
      });

      return imageids;
   },

   getObjectid: function () {
      let objectContainer = $('story-video-upload');
      let object = objectContainer.getFirst('.mediaTarget input');
      return Number.parseInt(object.value, 10);
   },

   getGuideids: function () {
      let guideids = [];

      let guideid = this.guideInput.get('data-guideid');
      if (guideid && this.guideInput.value) {
         guideids.push(Number.parseInt(guideid, 10));
      }

      return guideids;
   },

   getDifficulty: function () {
      return this.storyDifficulty.value;
   },

   getTimeTaken: function () {
      return this.getGuideids().length ? this.timeTaken.value.toInt() : null;
   },

   getProducts: function () {
      let products = [];

      let productCode = this.productInput.get('data-productcode');
      if (productCode && this.productInput.value) {
         products.push(productCode);
      }

      return products;
   },
};
